/**
 * Supported Chirp GraphQL Gateways
 */
export const loadBalancers = {
  APP: 'app',
  TOOLS: 'tools',
  PRIVATEHUBTEAM: 'privatehubteam',
  GLOBAL: 'global',
} as const;

export const chirpGateways = {
  APP: 'app',
  INTERNAL: 'internal',
  TEST: 'test',
  EXTERNAL: 'external',
} as const;

export const environments = {
  QA: 'qa',
  PROD: 'prod',
} as const;
